var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 3.81845L10.5454 9.72754L1.45454 9.72754L1.45454 3.81845L10.5454 3.81845Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27271 2.45472L8.27271 3.81836L3.72725 3.81836L3.72725 2.45472L8.27271 2.45472Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18179 2.90927L9.18179 3.81836L2.81816 3.81836L2.81816 2.90927L9.18179 2.90927Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0909 3.36381L10.0909 3.81836L1.90907 3.81836L1.90907 3.36381L10.0909 3.36381Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 9.27299L10.5454 9.72754L11 9.72754L11 9.27299L10.5454 9.27299Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0909 9.72807L10.0909 10.1826L10.5454 10.1826L10.5454 9.72807L10.0909 9.72807Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 8.81889L10.5454 9.27344L11 9.27344L11 8.81889L10.5454 8.81889Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 8.36381L10.5454 8.81836L11 8.81836L11 8.36381L10.5454 8.36381Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 7.90874L10.5454 8.36328L11 8.36328L11 7.90874L10.5454 7.90874Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 7.45463L10.5454 7.90918L11 7.90918L11 7.45463L10.5454 7.45463Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 7.00053L10.5454 7.45508L11 7.45508L11 7.00053L10.5454 7.00053Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 6.54545L10.5454 7L11 7L11 6.54545L10.5454 6.54545Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 6.09038L10.5454 6.54492L11 6.54492L11 6.09038L10.5454 6.09038Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 5.63628L10.5454 6.09082L11 6.09082L11 5.63628L10.5454 5.63628Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 5.18217L10.5454 5.63672L11 5.63672L11 5.18217L10.5454 5.18217Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 4.72807L10.5454 5.18262L11 5.18262L11 4.72807L10.5454 4.72807Z",
    fill: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 4.27299L10.5454 4.72754L11 4.72754L11 4.27299L10.5454 4.27299Z",
    fill: "currentColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 3.81889L10.5454 4.27344L11 4.27344L11 3.81889L10.5454 3.81889Z",
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 3.36381L10.5454 3.81836L11 3.81836L11 3.36381L10.5454 3.36381Z",
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0909 3.36381L10.0909 3.81836L10.5454 3.81836L10.5454 3.36381L10.0909 3.36381Z",
    fill: "currentColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0909 2.90874L10.0909 3.36328L10.5454 3.36328L10.5454 2.90874L10.0909 2.90874Z",
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63635 2.90874L9.63635 3.36328L10.0909 3.36328L10.0909 2.90874L9.63635 2.90874Z",
    fill: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18179 2.90874L9.18179 3.36328L9.63634 3.36328L9.63634 2.90874L9.18179 2.90874Z",
    fill: "currentColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18179 2.45463L9.18179 2.90918L9.63634 2.90918L9.63634 2.45463L9.18179 2.45463Z",
    fill: "currentColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72723 2.45463L8.72723 2.90918L9.18178 2.90918L9.18178 2.45463L8.72723 2.45463Z",
    fill: "currentColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27271 2.45463L8.27271 2.90918L8.72725 2.90918L8.72725 2.45463L8.27271 2.45463Z",
    fill: "currentColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27271 1.99956L8.27271 2.4541L8.72725 2.4541L8.72725 1.99956L8.27271 1.99956Z",
    fill: "currentColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 9.27299L1.45453 9.72754L0.999984 9.72754L0.999984 9.27299L1.45453 9.27299Z",
    fill: "currentColor"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0909 9.72807L10.0909 10.1826L1.45452 10.1826L1.45452 9.72807L10.0909 9.72807Z",
    fill: "currentColor"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 8.81889L1.45453 9.27344L0.999984 9.27344L0.999984 8.81889L1.45453 8.81889Z",
    fill: "currentColor"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 8.36381L1.45453 8.81836L0.999984 8.81836L0.999984 8.36381L1.45453 8.36381Z",
    fill: "currentColor"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 7.90874L1.45453 8.36328L0.999984 8.36328L0.999984 7.90874L1.45453 7.90874Z",
    fill: "currentColor"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 7.45463L1.45453 7.90918L0.999984 7.90918L0.999984 7.45463L1.45453 7.45463Z",
    fill: "currentColor"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 7.00053L1.45453 7.45508L0.999984 7.45508L0.999984 7.00053L1.45453 7.00053Z",
    fill: "currentColor"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 6.54545L1.45453 7L0.999984 7L0.999984 6.54545L1.45453 6.54545Z",
    fill: "currentColor"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 6.09038L1.45453 6.54492L0.999984 6.54492L0.999984 6.09038L1.45453 6.09038Z",
    fill: "currentColor"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 5.63628L1.45453 6.09082L0.999984 6.09082L0.999984 5.63628L1.45453 5.63628Z",
    fill: "currentColor"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 5.18217L1.45453 5.63672L0.999984 5.63672L0.999984 5.18217L1.45453 5.18217Z",
    fill: "currentColor"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 4.72807L1.45453 5.18262L0.999984 5.18262L0.999984 4.72807L1.45453 4.72807Z",
    fill: "currentColor"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 4.27299L1.45453 4.72754L0.999984 4.72754L0.999984 4.27299L1.45453 4.27299Z",
    fill: "currentColor"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 3.81889L1.45453 4.27344L0.999984 4.27344L0.999984 3.81889L1.45453 3.81889Z",
    fill: "currentColor"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45453 3.36381L1.45453 3.81836L0.999984 3.81836L0.999984 3.36381L1.45453 3.36381Z",
    fill: "currentColor"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90906 3.36381L1.90906 3.81836L1.45451 3.81836L1.45451 3.36381L1.90906 3.36381Z",
    fill: "currentColor"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90906 2.90874L1.90906 3.36328L1.45451 3.36328L1.45451 2.90874L1.90906 2.90874Z",
    fill: "currentColor"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36362 2.90874L2.36362 3.36328L1.90907 3.36328L1.90907 2.90874L2.36362 2.90874Z",
    fill: "currentColor"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81818 2.90874L2.81818 3.36328L2.36363 3.36328L2.36363 2.90874L2.81818 2.90874Z",
    fill: "currentColor"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81818 2.45463L2.81818 2.90918L2.36363 2.90918L2.36363 2.45463L2.81818 2.45463Z",
    fill: "currentColor"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27271 2.45463L3.27271 2.90918L2.81816 2.90918L2.81816 2.45463L3.27271 2.45463Z",
    fill: "currentColor"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72726 2.45463L3.72726 2.90918L3.27272 2.90918L3.27272 2.45463L3.72726 2.45463Z",
    fill: "currentColor"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72726 1.99956L3.72726 2.4541L3.27272 2.4541L3.27272 1.99956L3.72726 1.99956Z",
    fill: "currentColor"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72726 1.99956L3.72726 2.4541L8.27272 2.4541L8.27272 1.99956L3.72726 1.99956Z",
    fill: "currentColor"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90907 6.54492H1.45453V6.99947H1.90907V6.54492Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3636 6.54492H1.90906V6.99947H2.3636V6.54492Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81816 4.72754H2.36362V6.09117H2.81816V4.72754Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63634 4.72754H9.18179V6.09117H9.63634V4.72754Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5454 6.54492H10.0909V6.99947H10.5454V6.54492Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0909 6.54492H9.63635V6.99947H10.0909V6.54492Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18185 7.00053L9.18185 7.45508L9.6364 7.45508L9.6364 7.00053L9.18185 7.00053Z",
    fill: "currentColor"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36365 7.00053L2.36365 7.45508L2.81819 7.45508L2.81819 7.00053L2.36365 7.00053Z",
    fill: "currentColor"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36365 6.74747L2.36365 7L1.45456 7L1.45456 6.74747L2.36365 6.74747Z",
    fill: "currentColor"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36365 7.00053L2.36365 7.45508L1.45456 7.45508L1.45456 7.00053L2.36365 7.00053Z",
    fill: "currentColor"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18185 7.45561L4.18185 7.91016L2.36367 7.91016L2.36367 7.45561L4.18185 7.45561Z",
    fill: "currentColor"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63641 7.00053L9.63641 7.45508L10.5455 7.45508L10.5455 7.00053L9.63641 7.00053Z",
    fill: "currentColor"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81824 7.45561L7.81824 7.91016L9.63642 7.91016L9.63642 7.45561L7.81824 7.45561Z",
    fill: "currentColor"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27277 7.00053L3.27277 7.45508L2.81822 7.45508L2.81822 7.00053L3.27277 7.00053Z",
    fill: "currentColor"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18185 7.00053L9.18185 7.45508L8.72731 7.45508L8.72731 7.00053L9.18185 7.00053Z",
    fill: "currentColor"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5455 6.74747L10.5455 7L9.63638 7L9.63638 6.74747L10.5455 6.74747Z",
    fill: "currentColor"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0455 7.90971L3.0455 8.36426L3.50005 8.36426L3.50005 7.90971L3.0455 7.90971Z",
    fill: "currentColor"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50003 7.90971L3.50003 8.36426L8.04548 8.36426L8.04548 7.90971L3.50003 7.90971Z",
    fill: "currentColor"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95459 8.36381L3.95459 8.81836L4.40913 8.81836L4.40913 8.36381L3.95459 8.36381Z",
    fill: "currentColor"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63641 8.81849L4.63641 9.02051L7.36368 9.02051L7.36368 8.81849L4.63641 8.81849Z",
    fill: "currentColor"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90912 7.45423L1.90912 7.65625L2.36366 7.65625L2.36366 7.45423L1.90912 7.45423Z",
    fill: "currentColor"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45459 6.2935L1.45459 6.74805L1.90913 6.74805L1.90913 6.2935L1.45459 6.2935Z",
    fill: "currentColor"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0909 6.2935L10.0909 6.74805L10.5455 6.74805L10.5455 6.2935L10.0909 6.2935Z",
    fill: "currentColor"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63641 7.45423L9.63641 7.65625L10.091 7.65625L10.091 7.45423L9.63641 7.45423Z",
    fill: "currentColor"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18185 7.70814L4.18185 7.91016L4.6364 7.91016L4.6364 7.70814L4.18185 7.70814Z",
    fill: "currentColor"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63641 7.70814L4.63641 7.91016L5.09096 7.91016L5.09096 7.70814L4.63641 7.70814Z",
    fill: "currentColor"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90912 7.70814L6.90912 7.91016L7.36366 7.91016L7.36366 7.70814L6.90912 7.70814Z",
    fill: "currentColor"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36365 7.70814L7.36365 7.91016L7.81819 7.91016L7.81819 7.70814L7.36365 7.70814Z",
    fill: "currentColor"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95456 7.90971L8.95456 8.36426L8.50001 8.36426L8.50001 7.90971L8.95456 7.90971Z",
    fill: "currentColor"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50003 7.90971L8.50003 8.36426L8.04549 8.36426L8.04549 7.90971L8.50003 7.90971Z",
    fill: "currentColor"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04547 8.36381L8.04547 8.81836L4.40911 8.81836L4.40911 8.36381L8.04547 8.36381Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.36362,
    y: 5.11816,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75323,
    y: 4.92285,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.14282,
    y: 4.72852,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.53241,
    y: 4.72852,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.92212,
    y: 4.72852,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.31174,
    y: 4.92285,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4.70123,
    y: 5.31348,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.70123,
    y: 5.70215,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 4.31174,
    y: 5.70215,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 3.92212,
    y: 5.50781,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3.53241,
    y: 5.50781,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 3.14282,
    y: 5.70215,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75323,
    y: 5.70215,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 2.36362,
    y: 5.50781,
    width: 0.389611,
    height: 0.389611,
    fill: "currentColor"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75323,
    y: 5.11816,
    width: 1.94805,
    height: 0.584416,
    fill: "currentColor"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 9.63632 5.11816)",
    fill: "currentColor"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 9.24673 4.92285)",
    fill: "currentColor"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 8.85712 4.72852)",
    fill: "currentColor"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 8.46753 4.72852)",
    fill: "currentColor"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 8.07782 4.72852)",
    fill: "currentColor"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 7.68823 4.92285)",
    fill: "currentColor"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 7.29871 5.31348)",
    fill: "currentColor"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 7.29871 5.70215)",
    fill: "currentColor"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 7.68823 5.70215)",
    fill: "currentColor"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 8.07782 5.50781)",
    fill: "currentColor"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 8.46753 5.50781)",
    fill: "currentColor"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 8.85712 5.70215)",
    fill: "currentColor"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 9.24673 5.70215)",
    fill: "currentColor"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 0.389611,
    height: 0.389611,
    transform: "matrix(-1 0 0 1 9.63632 5.50781)",
    fill: "currentColor"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 1.94805,
    height: 0.584416,
    transform: "matrix(-1 0 0 1 9.24673 5.11816)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoS);
export default __webpack_public_path__ + "static/media/logo-s.280b22176ceae13196c1c3832e22c4e0.svg";
export { ForwardRef as ReactComponent };